import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';

const ConfigureLink = ({ onClick }: { onClick?: () => void }) => {
  return (<div className='d-flex justify-content-center my-2'>
      <button
        type='button'
        className='d-flex align-items-center border-0 bg-transparent color-primary mr-4'
        onClick={onClick}
      >
        <NvIcon size='smallest' icon='edit' className='pr-2 d-inline-block ' />
        {t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CONFIGURE()}
      </button>
    </div>);
};

export default ConfigureLink;
